<template>
  <div class="steps-navigation">
    <div class="buttons-list-container">
      <span class="progress-bar" :style="progressBar"></span>
      <ul class="buttons-list">
        <li v-for="(label, i) in labels" :key="i">
          <button
            class="step-button" :class="{'is-active': active === i, 'is-completed': active > i}"
            :disabled="i > allowed"
            @click="updateActive(i)"
          >
            <span class="step-circle"></span>
            <span class="step-label">{{ label }}</span>
          </button>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      labels: {
        type: Array,
        default: () => []
      },
      activeIndex: {
        type: Number,
        default: 0
      },
      maxAllowed: {
        type: Number,
        default: 0
      }
    },
    data () {
      return {
        active: 0,
        allowed: 0
      }
    },
    computed: {
      progressBar () {
        let scale = this.active / (this.labels.length - 1)
        if (this.active < 0) scale = 0
        if (this.active > (this.labels.length - 1)) scale = 1
        return `transform: scaleX(${scale})`
      }
    },
    watch: {
      activeIndex: {
        immediate: true,
        handler (val) {
          if (val < 0 || val > this.labels.length - 1) return
          this.active = val 
        }
      },
      maxAllowed: {
        immediate: true,
        handler (val) {
          this.allowed = this.labels.length - 1
          if (val >= 0) this.allowed = val
        }
      }
    },
    methods: {
      updateActive (index) {
        this.active = index
        this.$emit('update', this.active)
      }
    }
  }
</script>

<style lang="scss" scoped>

  @import '../assets/styles/_variables.scss';
  @import '../assets/styles/_mixins.scss';

  .steps-navigation {
    max-width: 520px;
    margin: 0 auto;
    padding: 0 4em;

    @include screen(md) {
      padding: 0 2em;
    }

  }

  .buttons-list-container {
    position: relative;
    margin-bottom: 1.2em;

    &:before {
      content: '';
      position: absolute;
      top: 12px;
      left: 0;
      width: 100%;
      height: 2px;
      background-color: var(--ec-gray-light, lighten(black, 85));
    }

  }
  
  .progress-bar {
    position: absolute;
    top: 12px;
    left: 0;
    width: 100%;
    height: 2px;
    background-color: var(--ec-primary-color, black);
    transform-origin: 0 50%;
    transition: transform .2s ease-out;
  }

  .buttons-list {
    display: flex;
    justify-content: space-between;
    list-style: none;
    margin: 0;
    padding: 0;
  }

  .step-button {
    position: relative;
    background: transparent;
    color: inherit;
    border: 0;
    box-shadow: 0;
    padding: 0;
    font-weight: 700;
    outline: none;
    cursor: pointer;

    &:disabled {
      cursor: not-allowed;
    }

    &.is-active .step-circle:before {
      background-color: var(--ec-primary-color, black);
      transition: background-color .25s .15s ease-out;
    }

    &.is-completed .step-circle {
      border-color: var(--ec-primary-color);

      &:before {
        background-color: var(--ec-primary-color, black);
      }

    }

  }

  .step-circle {
    display: inline-block;
    position: relative;
    width: 24px;
    height: 24px;
    border-radius: 50%;
    background-color: white;
    border: 2px solid var(--ec-gray-light, lighten(black, 85));
    margin-bottom: .5em;

    &:before {
      content: '';
      position: absolute;
      top: 50%;
      left: 50%;
      width: 14px;
      height: 14px;
      background-color: var(--ec-gray-light, lighten(black, 85));
      border-radius: 50%;
      transform: translate(-50%, -50%);
    }

  }

  .step-label {
    font-family: var(--ec-headings-font, inherit);
    font-size: .75em;
    position: absolute;
    top: 100%;
    left: 50%;
    transform: translateX(-50%);
  }

</style>